export default __webpack_public_path__ + "static/media/Animation.12b960ca.mp4";